import { createReducer, on } from '@ngrx/store';
import { initialAuthUserStore } from './auth-user.store';
import { AuthUserActions } from './auth-user.actions';

export const authUserReducer = createReducer(
  initialAuthUserStore,

  on(AuthUserActions.initializePublicAuthentication, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(AuthUserActions.initializePublicAuthenticationSuccess, (state, { response }) => ({
    ...state,
    ...response,
    isAuthenticated: true,
    loginType: 'public' as const,
    isLoading: false,
    error: null,
    tokenExpiration: response.expiration
  })),

  on(AuthUserActions.initializePublicAuthenticationFailure, (state, { error }) => ({
    ...state,
    isAuthenticated: false,
    isLoading: false,
    error
  })),

  on(AuthUserActions.validatePublicAuthentication, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),

  on(AuthUserActions.validatePublicAuthenticationSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),

  on(AuthUserActions.validatePublicAuthenticationFailure, (state, { error }) => ({
    ...state,
    isAuthenticated: false,
    isLoading: false,
    error
  })),

  on(AuthUserActions.customerLogout, () => ({
    ...initialAuthUserStore,
    isLoading: false
  })),
);
